// src/components/users/UserBadges.jsx
import React from 'react';

const roles = {
  'admin': {
    label: 'Administrator',
    style: 'bg-purple-100 text-purple-800 border-purple-200'
  },
  'smt_member': {
    label: 'SMT Member',
    style: 'bg-blue-100 text-blue-800 border-blue-200'
  },
  'gb_member': {
    label: 'GB Member',
    style: 'bg-green-100 text-green-800 border-green-200'
  },
  'risk_owner': {
    label: 'Risk Owner',
    style: 'bg-yellow-100 text-yellow-800 border-yellow-200'
  },
  'staff': {
    label: 'Staff Member',
    style: 'bg-gray-100 text-gray-800 border-gray-200'
  }
};

const RoleBadge = ({ role }) => {
  const roleInfo = roles[role] || roles.staff;
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${roleInfo.style}`}>
      {roleInfo.label}
    </span>
  );
};

export { roles, RoleBadge };
